import { Box, IconButton, Button, Typography, Paper } from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import AnswerOptionRichEditor from "./AnswerOptionRichEditor";

const MatchingEditor = ({ options, setOptions }) => {
  const handleChange = (index, field, value) => {
    const updated = [...options];
    updated[index] = { ...updated[index], [field]: value };
    setOptions(updated);
  };

  const addPair = () => {
    if (options.length < 10) {
      setOptions([...options, { text: "", match_text: "" }]);
    }
  };

  const removePair = (index) => {
    if (options.length <= 2) return;
    setOptions(options.filter((_, i) => i !== index));
  };

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: "#444" }}>
        Matching Pairs (left item → right match)
      </Typography>
      {options.map((opt, index) => (
        <Paper
          key={index}
          elevation={0}
          sx={{ 
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
            mb: 1.5, 
            p: 1.5,
            border: "1px solid #e0e0e0",
            borderRadius: 1,
            background: "#fafafa",
          }}
        >
          <Box sx={{ 
            minWidth: 28, 
            height: 28, 
            borderRadius: "50%", 
            bgcolor: "#6366f1",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 12,
            fontWeight: 600,
          }}>
            {index + 1}
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <AnswerOptionRichEditor
              value={opt.text}
              onChange={(html) => handleChange(index, "text", html)}
              placeholder={`Item ${index + 1}`}
            />
          </Box>
          <Typography sx={{ mx: 1, color: "#6366f1", fontWeight: 600, flexShrink: 0 }}>→</Typography>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <AnswerOptionRichEditor
              value={opt.match_text}
              onChange={(html) => handleChange(index, "match_text", html)}
              placeholder={`Match ${index + 1}`}
            />
          </Box>
          <IconButton
            size="small"
            color="error"
            onClick={() => removePair(index)}
            disabled={options.length <= 2}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Paper>
      ))}
      <Button 
        size="small" 
        startIcon={<Add />} 
        onClick={addPair} 
        disabled={options.length >= 10}
        sx={{ 
          color: "#6366f1",
          "&:hover": { background: "rgba(99, 102, 241, 0.08)" }
        }}
      >
        Add Pair
      </Button>
    </Box>
  );
};

export default MatchingEditor;
